import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../store/configureStore";
import NotixProfile from "../Services/notix-profile";

export const NOT_YET = -1;

interface ICountersState {
  loading: boolean;
  status: number;
  billing: {
    enabled: boolean;
    monetization_enabled: boolean;
    plan: number;
    manual_plan_enabled: boolean;
  };
  legal_info: {
    legal_info_missing: boolean;
    legal_info_left_days: number;
    legal_info_blocked: boolean;
  };
  enabled: boolean;
  plan: number;
  features: {
    [feature: string]: boolean;
  } | null;
  want_to_monetization: 0 | 1 | 2;
  errors: any;
  want_to_monetization_disabled: boolean;
}

const initialState: ICountersState = {
  loading: false,
  status: NOT_YET,
  enabled: false,
  legal_info: {
    legal_info_missing: false,
    legal_info_left_days: 0,
    legal_info_blocked: false,
  },
  billing: {
    enabled: false,
    monetization_enabled: false,
    plan: 0,
    manual_plan_enabled: false,
  },
  features: {},
  plan: 0,
  want_to_monetization: 0,
  errors: {},
  want_to_monetization_disabled: false,
};

const notixProfileSlice = createSlice({
  name: "notixProfile",
  initialState,
  reducers: {
    setLoader: (state) => {
      state.loading = true;
      state.errors = initialState.errors;
    },
    setData: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.status = payload.status;
      state.enabled = payload.billing.enabled;
      state.plan = payload.billing.plan;
      state.legal_info.legal_info_missing =
        payload.legal_info.legal_info_missing;
      state.legal_info.legal_info_left_days =
        payload.legal_info.legal_info_left_days;
      state.legal_info.legal_info_blocked =
        payload.legal_info.legal_info_blocked;
      state.features = payload.features || null;
      state.billing.enabled = payload.billing.enabled;
      state.billing.monetization_enabled = payload.billing.monetization_enabled;
      state.billing.plan = payload.billing.plan;
      state.billing.manual_plan_enabled = payload.billing.manual_plan_enabled;
      state.want_to_monetization = payload.want_to_monetization;
      state.want_to_monetization_disabled =
        payload.want_to_monetization_disabled;
    },
    setError: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.errors = payload;
    },
    setBlockLegalInfo: (state) => {
      state.legal_info.legal_info_blocked = true;
    },
  },
});

export const {
  setLoader,
  setData,
  setError,
  setBlockLegalInfo,
} = notixProfileSlice.actions;

export const loadNotixProfile = (): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    const response = await NotixProfile.get();
    dispatch(setData(response));
  } catch (error) {
    dispatch(setError(error));
  }
};

export const triggerActualProfileData = (): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    return await NotixProfile.triggerActualProfileData();
  } catch (error) {
    dispatch(setError(error));
  }
};

export default notixProfileSlice.reducer;
